import React from 'react';

import { useMetadataListWithSelected } from '@lumapps/metadata-pickers/hooks/useMetadataListWithSelected';

import type { DrawerSectionProps } from '../DrawerSection';
import { DrawerMetadatasSection as UI } from './DrawerMetadatasSection';

export interface DrawerMetadatasSectionProps extends Partial<DrawerSectionProps> {
    /** list of metadatas to load */
    metadataIds?: string[];
    /** current instance id */
    instanceId: string;
    /** whether or not the returned metadata should only be root metadata. Default is true */
    rootOnly?: boolean;
}

/**
 * Displays a list of metadatas inside the context of a Drawer. This component retrieves the lists
 * of metadatas from the backend and displays them with their specific parents
 * @param DrawerMetadatasSectionProps
 * @returns DrawerMetadatasSection
 */
export const DrawerMetadatasSection: React.FC<DrawerMetadatasSectionProps> = ({
    metadataIds = [],
    instanceId,
    rootOnly = true,
    ...props
}) => {
    const { isLoading, parentMetadatas, selectedMetadatas } = useMetadataListWithSelected({
        params: {
            instance: instanceId,
            withInheritance: true,
            rootOnly,
            // We need to fetch all metadatas (or at least as much as we can) in order to display them.
            maxResults: '999',
        },
        selectedMetadatas: metadataIds,
    });

    return (
        <UI isLoading={isLoading} parentMetadatas={parentMetadatas} selectedMetadatas={selectedMetadatas} {...props} />
    );
};
